<template>
  <div v-if="visible" class="modal-acordo">
    <div class="modal-overlay" @click="fechar" />
    <div class="modal-content">
      <!-- HEADER -->
      <header class="modal-header">
        <h2>
          <span class="step"><strong>{{ step }}</strong>/{{ totalSteps }}</span>
          {{ title }}
        </h2>
      </header>

      <!-- RESUMO SUPERIOR -->
    <section class="modal-main">
      <div class="modal-summary" v-if="step !== 3">
        <div class="summary-text">
          <h3 class="summary-main">{{ resumoLinha1 }}</h3>
          <h3 class="summary-sub">{{ resumoLinha2 }}</h3>
        </div>
        <div class="summary-total">
          <h1>{{ currency(total) }}</h1>
        </div>
      </div>

      <!-- CORPO: ENTRADA E PARCELAS -->
      <div v-if="step === 1" class="modal-body">
        <div class="field" v-if="temEntrada">
          <div class="field-label">
            <h4>
              Entrada
              <template v-if="entradaParcelada">
                <span class="input-detail">({{ parcelasEntrada }}x)</span>
              </template>
            </h4>
            <small v-if="temRangeEntrada">De {{ minEntrada }}% até {{ maxEntrada }}%</small>
          </div>
          <div class="field-control">
            <div class="input-circle">
              <input
                type="number"
                placeholder="35"
                v-model.number="entradaPercent"
                :min="minEntrada"
                :max="maxEntrada"
              />
              <span class="unit">%</span>
            </div>
            <div class="field-equals">
              <h5>=</h5>
              <h3><strong>{{ currency(valorEntrada) }}</strong></h3>
            </div>
          </div>
        </div>


        <div class="field">
          <div class="field-label">
            <h4>Parcelas</h4>
            <small>De 1 a {{ maxParcelas }}x</small>
          </div>
          <div class="field-control">
            <div class="input-circle">
              <input
                type="number"
                v-model.number="parcelas"
                placeholder="3"
                min="1"
                :max="maxParcelas"
              />
              <span class="unit">x</span>
            </div>
            <div class="field-equals">
              <h5>=</h5> <h3><strong>{{ currency(valorParcela) }}</strong></h3>
            </div>
          </div>
        </div>
      </div>

      <div v-if="step === 2" class="modal-body">
      <table class="tabela-parcelas">
        <tbody>
          <tr v-for="(parcela, index) in parcelasCalculadas" :key="index">
            <td class="number-boleto">{{ String(index + 1).padStart(2, '0') }}</td>
            <td>{{ parcela.tipoArrecadacao === 'entrada' ? 'Entrada' : `Parcela ${parcela.parcela}` }}</td>
            <td>
              <input type="date" v-model="parcela.vencimento" />
            </td>
            <td>{{ currency(parcela.valor) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

      <div v-if="step === 3" class="modal-body">
      <main class="tabela-acordo text-center">
        <h4>TERMO DE CONFISSÃO DE DIVÍDA</h4>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Ratione consectetur voluptate repudiandae. Placeat veniam totam quod laboriosam qui blanditiis voluptates, impedit perspiciatis minima odio soluta atque obcaecati fugit! Accusantium maxime quod veniam facere dolorum, adipisci, et aperiam at sunt, eaque asperiores ducimus officiis cupiditate! Officiis, sapiente perferendis neque nobis tempora facere quia nam in a recusandae eligendi praesentium animi, iste nulla assumenda? Facilis alias corporis enim vel illo, nam ut, quos quis ipsum repudiandae consectetur, ducimus qui error magnam veritatis maiores reprehenderit dolore. Quos dignissimos consectetur recusandae, cumque, adipisci unde asperiores voluptate laudantium sunt magnam suscipit tempora hic ad vel autem molestias commodi voluptas alias quasi minus, quae pariatur iusto vitae maiores. Eligendi non doloribus ut illo illum blanditiis laboriosam quisquam esse! Nostrum quasi rerum harum nemo consequuntur accusamus animi amet quibusdam sit. Tempora quis minima, recusandae aliquam, eum laboriosam rem illo ex, tenetur quae ea iusto. Quod qui, cupiditate, cum delectus, ipsa temporibus dolores doloremque sit velit unde magnam! Dolorum, tempora! Est delectus voluptatibus veritatis ab inventore id quaerat hic deleniti perspiciatis, sint ipsum exercitationem quae voluptate cupiditate eaque? Consequatur voluptate, eum laborum dolorem sint laudantium rerum reiciendis earum tenetur corrupti, aperiam fuga quod modi ea! Non ad consequatur, amet ipsam qui assumenda totam quae. Ex esse delectus beatae, reprehenderit perspiciatis est quo maxime rem totam sequi doloremque repellat necessitatibus, temporibus, ipsum ratione quasi saepe alias qui doloribus! Voluptates dignissimos inventore, iste quis atque est ab totam repudiandae cupiditate eum? Facere qui ea at assumenda quaerat quod repellendus nulla, recusandae explicabo soluta officia atque dolorem corrupti dicta repellat magnam fugit amet facilis ipsam. Perspiciatis consequatur error eum quas sit tempore. Dignissimos nam distinctio ducimus doloremque maxime! Impedit odio, quos, reprehenderit blanditiis porro ipsa facere voluptatum, perspiciatis aut atque voluptates eius ipsam quis? Porro officia corrupti, non exercitationem veniam odit laboriosam atque. Ducimus ea harum maxime vitae aspernatur repudiandae quis laborum qui praesentium? Libero illum soluta sequi optio assumenda corrupti alias quisquam! Pariatur voluptatem nostrum perspiciatis eius. Earum repudiandae blanditiis vitae asperiores quidem ea neque possimus eius quisquam consequatur aut distinctio nihil amet, tempore, ratione velit? Hic doloribus laudantium illum eius. Aperiam culpa ut molestiae officiis provident neque perspiciatis maxime perferendis nostrum mollitia obcaecati vero, illum cum ipsa rerum incidunt accusantium iure odio? Doloribus, ullam labore. Perferendis, dolorem. Repellat minus modi doloribus temporibus rem! Debitis repudiandae nostrum hic quo saepe quam odio culpa dolorem distinctio architecto laborum laudantium sed sint, minus modi blanditiis magni explicabo asperiores eum iusto quasi similique! Sunt, ipsam. Voluptas veniam, fuga rerum cumque consectetur doloribus! Veniam nesciunt officia consectetur nam mollitia sunt odit quia quibusdam fugit ea ratione quam expedita reprehenderit, natus aut recusandae nihil vitae? Quos ratione assumenda possimus quia animi dicta consectetur provident. Amet, ipsa accusantium. Rem nam porro, amet beatae explicabo odio facilis, soluta commodi minima earum, natus molestiae. Aperiam amet fuga culpa non consequatur sed voluptatum nostrum! Libero asperiores error vel rerum dolorum alias id neque non assumenda labore quod dolore unde corporis tempora iure facere nesciunt voluptate quisquam ipsam, quia ipsa beatae optio quaerat. Ad minus sapiente recusandae inventore, qui pariatur et nulla veniam tempora, dolorem nam? Aliquid sapiente exercitationem praesentium non! Quod deleniti, neque doloribus eveniet tempore recusandae laboriosam sit alias, ad mollitia, dolores quae. Delectus at inventore ea obcaecati illum tempore, magnam culpa. Totam magnam ratione iste corporis, id consequatur beatae eligendi atque est repellendus sunt nesciunt numquam sint, veritatis officia nostrum expedita temporibus magni modi blanditiis laudantium molestias. Dolores facere suscipit, cum illo quod non facilis architecto magni beatae vero omnis soluta quos dolor perspiciatis reiciendis odio nostrum delectus unde veritatis consequuntur est autem itaque fugit. Architecto possimus, atque magni quidem, ex reprehenderit illo, accusantium minus praesentium doloribus similique nemo nisi fuga accusamus tempore iste. Iusto voluptatem, suscipit dolorum tempora similique asperiores necessitatibus aliquid libero neque aspernatur rerum aperiam reiciendis. Mollitia illo amet ipsum vero quibusdam dicta enim doloremque iusto assumenda accusamus maxime reprehenderit nostrum dolores repellat consequatur, eius error, ratione similique nesciunt omnis reiciendis placeat harum doloribus fugiat! Aperiam laborum aliquid sint odio, libero rerum earum sit doloribus numquam voluptas ullam quam dolore quasi, cupiditate, quod culpa. Reprehenderit suscipit officiis numquam, veritatis, ratione dolores sequi sunt nostrum labore ab totam tenetur nobis eum distinctio. Eveniet reiciendis, deleniti magnam debitis vitae maiores consectetur nostrum accusantium atque nam nobis dignissimos at molestiae architecto tenetur saepe in tempore suscipit voluptatem possimus, laboriosam, inventore repudiandae. Porro illo neque tempora id corrupti quo recusandae dignissimos, dolor perspiciatis optio cum velit libero adipisci totam expedita atque delectus quidem facilis. Eveniet illo, assumenda illum repudiandae dolores maiores perspiciatis? Fugit excepturi cumque dolores quos ea optio! Nam qui aperiam sapiente. Nulla modi in placeat odio fugiat labore dignissimos incidunt ex voluptas consequuntur veniam doloribus ipsam, corporis explicabo! Officiis molestias tempore earum reprehenderit rem dolorem temporibus beatae nostrum! Dolores quibusdam doloribus necessitatibus incidunt similique distinctio rem vitae aspernatur quas possimus? Tenetur dolor nobis consequatur quos rem vitae, aspernatur quae in culpa nisi alias facere vero excepturi error. Velit, numquam laudantium. Tempore earum eius hic cupiditate cum officiis iste dolores a consectetur eligendi voluptatum atque maiores vitae, ipsam non incidunt odio delectus placeat optio voluptas. Voluptatum quam dignissimos nemo, aut consectetur laborum assumenda minima architecto repellat magnam earum similique ducimus laboriosam perspiciatis repellendus natus excepturi blanditiis eum voluptatibus possimus. Neque magni delectus quibusdam obcaecati incidunt rerum fugiat ratione et aspernatur ad? Quidem expedita eaque minima. Ipsum iure qui a optio eveniet repellat incidunt excepturi. Qui voluptatum doloremque ex ducimus odit soluta assumenda ipsum laboriosam, non nostrum blanditiis, quaerat modi laborum aliquid nihil quis obcaecati est id repudiandae ipsam quisquam incidunt minus quam debitis! Necessitatibus totam dolores magni sed quaerat. Illo vitae nobis laborum delectus eveniet sunt esse autem quae, expedita obcaecati exercitationem rerum error quos beatae in nostrum quam iure placeat fugiat nulla blanditiis deleniti modi perferendis sequi. Similique ipsam tempore ad quibusdam exercitationem illo est recusandae, fugiat minima. In amet sed doloribus cumque, voluptas omnis, ipsum vel, recusandae similique ducimus aliquid atque esse! Obcaecati, eligendi cupiditate consequuntur beatae quisquam molestias minus, praesentium ratione mollitia architecto ullam.
      </main>
    </div>
    </section>

      <!-- FOOTER -->
      <footer class="modal-footer">
        <button class="btn  btn-secondary" @click="fechar">
          Voltar
        </button>
        <button class="btn btn-primary" @click="onContinuar">
          Continuar
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalAcordo',
  props: {
    visible: { type: Boolean, default: false },
    forma: { type: Object,  required: true },
    step: { type: Number,  default: 1 },
    totalSteps: { type: Number,  default: 3 },
    title: { type: String,  default: 'Confirmação do Acordo' },
  },
  data() {
    return {
      entradaPercent: 35,
      parcelas: 6,
      model: {
        "cpf_responsavel_financeiro": "30804759847",
        "mencodigos": [
            1803412,
            1496760,
            1803415,
            1803413
        ], 
        "valor": {
          totalOriginal: 5570.89,
          totalFinal: 6570.47  
        },
        "formaPagamento": {
            idFormaPagamento: 3,
            percentualEntrada: 35, //pode ser nulo caso a forma de pagamento não tenha esse parametro
            qtdParcelas: 5, //pode ser nulo caso a forma de pagamento não tenha esse parametro
            //os parametros não estaram dispponiveis caso a forma de pagamento não seja variavel nesse caso as regras estarão disponiveis na configuração da forma de pagamento
        },
        
        "parcelas": [
            {
                tipoArrecadacao: 'entrada', 
                parcela: 1,
                vencimento: "2025-07-31",
                valor: 1215.96,
                
            },
            {
                tipoArrecadacao: 'parcela', 
                parcela: 1,
                vencimento: "2025-08-31",
                valor: 1215.96,
                
            },
            {
                tipoArrecadacao: 'parcela', 
                parcela: 2,
                vencimento: "2025-09-31",
                valor: 1215.96,
                
            }
        ]
      }
    };
  },
  
  computed: {
  temEntrada() {
    return this.forma?.entrada !== null;
  },
  entradaParcelada() {
    return this.forma?.entrada?.cartao?.parcelasEntrada && parseInt(this.forma.entrada.cartao.parcelasEntrada) > 1
  },
  parcelasEntrada() {
    return this.forma?.entrada?.cartao?.parcelasEntrada
  },
  temRangeEntrada() {
    return this.minEntrada !== null && this.maxEntrada !== null
  },
    parcelasCalculadas() {
      const lista = [];

      if (this.temEntrada) {
        lista.push({
          tipoArrecadacao: 'entrada',
          parcela: 1,
          vencimento: this.dataHoje(),
          valor: this.valorEntrada
        });
      }

      for (let i = 0; i < this.parcelas; i++) {
        lista.push({
          tipoArrecadacao: 'parcela',
          parcela: i + 1,
          vencimento: this.addMeses(this.dataHoje(), i + 1),
          valor: this.valorParcela
        });
      }

      return lista;
    },
    total() { return this.forma.valorFinalCobrado },
    minEntrada()  { return this.forma.minEntrada },
    maxEntrada()  { return this.forma.maxEntrada },
    maxParcelas() { return this.forma.maxParcelas },
    valorEntrada() {
      return this.temEntrada ? (this.entradaPercent / 100) * this.total : 0
    },
    valorParcela() {
      const valorBase = this.temEntrada ? (this.total - this.valorEntrada) : this.total
      return valorBase / this.parcelas
    },
    resumoLinha1() {
       return this.forma?.nome
    },
    resumoLinha2() {
      if (!this.temEntrada) {
        return `${this.parcelas}x de ${this.currency(this.valorParcela)}`
      }
      return `Entrada de ${this.currency(this.valorEntrada)} + ${this.parcelas}x de ${this.currency(this.valorParcela)}`
    }
  },
  methods: {

    dataHoje() {
      return new Date().toISOString().substr(0, 10)
    },
    addMeses(data, meses) {
      const novaData = new Date(data)
      novaData.setMonth(novaData.getMonth() + meses)
      return novaData.toISOString().substr(0, 10)
    },
    fechar() {
      this.$emit('fechar')
    },
    onContinuar() {
      if (this.step < this.totalSteps) {
        this.$emit('update:step', this.step + 1)
      } else {
        this.$emit('finalizar', {
          entradaPercent: this.entradaPercent,
          parcelas: this.parcelas,
          valorEntrada: this.valorEntrada,
          valorParcela: this.valorParcela,
          parcelasDetalhadas: this.parcelasCalculadas
        });
      }
    },
    currency(val) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency', currency: 'BRL'
      }).format(val)
    },
  },
};
</script>

<style lang="scss" scoped>

.input-detail{
  color: $cinza-escuro;
}

.number-boleto{
  text-align: start !important;
}

.tabela-acordo{
  overflow-y: auto;
  padding: $mg-small;

  @extend %scrollbar_light;

}

.tabela-parcelas{
  margin-top: 7rem;

  input{
    border: none;
    color: $cinza-escuro;

      &:focus {
        border: 0; outline: 0; box-shadow: none;
      }

    :focus{
      outline: none;
    }
  }
}

// .tabela-parcelas{
//   height: 20rem;
//   overflow-y: auto;


          table {

          width: 100%;
          padding: 0 !important; 
          border-collapse: collapse;
          overflow: hidden;
          table-layout: fixed;

          thead {
            border-top: $border-component;

            tr {
              height: 50px;
              
              th {
                font-size: $font-size-small;
                padding: 0 $hmg_mid;
                text-align: center;

                &:nth-last-child( -n + 2 ) {
                  min-width: 280px; width: 20%; max-width: 360px;
                }
              }
            }
          }
          tbody {
            overflow: hidden;
            height: auto;
            border-top: $border-component;

            tr {
              height: 50px;
              overflow: hidden;

              td {
                border-top: $border-component;
                padding: 0 $hmg_mid;
                position: relative;
                text-align: center;
                justify-content: space-between;
                z-index: 8;

              .input-control{
                border: none !important;
              }
                
                
                &:first-child {
                  border-left: none !important;
                }
                &:last-child {
                  border-right: none !important;
                }

                &.over {
                  background-color: $color-debito;
                }
                &.under {
                  background-color: $color-credito;
                }

                &.fullCell {
                  padding: 0;
                  gap: $mg_small;
                }

                .fullCell{
                  display: flex;
                  justify-content: space-between;
                  width: 100%;
                }

                // .arrowTag {
                //   display: flex; flex-direction: column;
                //   justify-content: center; align-items: center;
                //   position: absolute; top: 50%; left: 0;
                //   transform: translate(-50%, -50%);
                //   width: 21px; height: 21px;
                //   border-radius: 100%; border: $border-component;
                //   font-size: 10px;
                //   z-index: 12;
                //   color: $vermelho; background-color: $color-secondary;

                //   &.over {
                //     color: $color-primary;
                //   }

                //   &.under {
                //     color: $color-success-2;
                //   }
                // }

                &.arrowCell {
                  >div {
                    display: flex; align-items: center; justify-content: center;
                    gap: $hmg_mini
                  }
                }

                .multiple {
                  display: flex; align-items: center;
                  gap: $mg_mini; overflow: hidden;
                  
                  span {
                    display: block;
                    width: 24px; height: 24px;
                    text-align: center; line-height: 24px;
                    flex-shrink: 0;
                    border: $border-component;
                    border-radius: 100%;
                  }
                  p {
                    margin: 0; padding: 0;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                  }
                }
              }

              &.spinner {
                height: auto;

                td {
                  background-color: $color-secondary;
                  padding: 0 !important;
                }
              }
              &.subHeader {
                height: 40px;
                background-color: $color-bg;

                h4 {
                  margin: 0; padding: 0;
                }
              }

              &:last-child {
                td {
                  border-bottom: none !important;

                  &:last-child {
                    border-right: none !important;
                    border-bottom-right-radius: $border-radius;
                  }
                }
              }
            }
          }
        }
// }
.modal-main{
  display: flex;
  flex-direction: column;
  padding: $mg-small;
}

.modal-acordo {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;

  .modal-overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
  }

  .modal-content {
    position: relative;
    background: $branco;
    border-radius: $border-radius-mid;
    width: 700px;
    max-width: 90%;
    @extend %shadow-high;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .modal-header {
      padding: $hmg;
      border-bottom: $border-component;
      h2 {
        
        .step {
          color: $cinza-escuro;
          margin-right: 0.5rem;
          font-weight: normal;
        }
      }
    }

    .modal-summary {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 1rem 1.5rem;
      border: $border-component;

      .summary-text {
        .summary-main {
          font-size: $font-size-large;
          color: $preto;
          margin: 0;
        }
        .summary-sub {
          font-size: $font-size-small;
          color: $cinza-escuro;
          margin-top: 0.25rem;
        }
      }
      .summary-total {
        font-size: 1.5rem;
        font-weight: bold;
        color: $vermelho;
      }
    }

    .modal-body {
        border: $border-component;
        border-top: none;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding: 0 !important;
        height: 20rem;
        overflow-y: auto;
        @extend %scrollbar_light;

        .field {
          width: 70%;
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: end;
            margin-bottom: 1rem;
            gap: $mg-mini;

            .field-label {
              width: 12rem;
              align-items: end;
            // flex: 1;
            span {
                display: block;
                font-size: $font-size;
                color: $preto;
            }
            small {
                display: block;
                font-size: $font-size-small;
                color: $cinza-escuro;
                margin-top: 0.25rem;
            }
            }

            .arrowTag {
            display: flex; flex-direction: column;
            justify-content: center; align-items: center;
            position: absolute; top: 50%; left: 0;
            transform: translate(-50%, -50%);
            width: 21px; height: 21px;
            border-radius: 100%; border: $border-component;
            font-size: 10px;
            z-index: 12;
            color: $vermelho; background-color: $color-secondary;
            &.over {
                color: $color-primary;
            }
            &.under {
                color: $color-success-2;
            }
            }

            .field-control {
            display: flex;
            align-items: center;

            .input-circle {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 5rem;
                color: $cinza-escuro;
                height: 5rem;
                border: $border-component;
                border-radius: $border-radius;
                input {
                width: 2rem;
                border: none;
                font-size: $font-size-large;
                text-align: right;
                &:focus { outline: none; }
                }
                .unit {
                margin-left: 0.25rem;
                font-size: $font-size;
                }
            }

            .field-equals {
              display: flex;
              width: 15rem;
              justify-content: flex-start;
              align-items: center;
                font-size: $font-size;
                color: $cinza-escuro;
                strong {
                margin-left: 0.25rem;
                }
            }
            }
        }
    }

    .modal-footer {
      padding: 1rem 1.5rem;
      background: $cinza-claro;
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
